module.exports = __webpack_public_path__ + "media/images/menu-f00e2080025681cdfae3542d27c70e9f.svg";